import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../../../../icons";
const ErrorIndicator = () => {
    return (_jsxs("div", { "aria-hidden": true, className: "absolute inset-0 z-10 block hidden h-full w-full flex-col items-center justify-center gap-2 bg-black text-white group-data-[error]:flex", children: [_jsx(Icon, { name: "video-off", size: "md" }), _jsx("span", { children: "Erro ao carregar o v\u00EDdeo" })] }));
};
ErrorIndicator.displayName = "ErrorIndicator";
export default ErrorIndicator;
